import Grid from "@material-ui/core/Grid";
import React from "react";
import PropTypes from "prop-types";
import RemoveButton from "../../../../common/RemoveButton/RemoveButton";
import TextBox from "../../../../common/TextBox";
import TimePicker from "../../../../common/TimePicker/TimePicker";

const OnDemandSlot = ({
  tabIndex,
  formIndex,
  slotIndex,
  slotCapacity,
  serviceStartTime,
  serviceEndTime,
  handleRemoveOnDemandSlot,
  handleIndividualSlotFieldsChange,
  handleOnDemandServiceTimeChange,
}) => {
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <TimePicker
            fieldLabel={slotIndex === 0 ? "First customer order time" : ""}
            value={serviceStartTime}
            handleChange={(date) =>
              handleOnDemandServiceTimeChange(
                tabIndex,
                formIndex,
                slotIndex,
                date,
                "startTime"
              )
            }
          />
        </Grid>
        <Grid item xs={4}>
          <TimePicker
            fieldLabel={slotIndex === 0 ? "Last order Cut-off Time" : ""}
            value={serviceEndTime}
            handleChange={(date) =>
              handleOnDemandServiceTimeChange(
                tabIndex,
                formIndex,
                slotIndex,
                date,
                "endTime"
              )
            }
          />
        </Grid>
        <Grid item xs={3}>
          <TextBox
            type="number"
            name="slotCapacity"
            fieldLabel={slotIndex === 0 ? "Capacity" : ""}
            value={slotCapacity}
            handleChange={(e) =>
              handleIndividualSlotFieldsChange(
                tabIndex,
                formIndex,
                slotIndex,
                e
              )
            }
            placeholderText="Enter Capacity"
            isNegativeAllowed={false}
          />
        </Grid>
        {slotIndex !== 0 ? (
          <Grid item xs={1}>
            <RemoveButton
              onClick={() =>
                handleRemoveOnDemandSlot(tabIndex, formIndex, slotIndex)
              }
            />
          </Grid>
        ) : null}
      </Grid>
    </div>
  );
};

OnDemandSlot.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  formIndex: PropTypes.number.isRequired,
  slotIndex: PropTypes.number.isRequired,
  slotCapacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  serviceStartTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  serviceEndTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  handleRemoveOnDemandSlot: PropTypes.func.isRequired,
  handleIndividualSlotFieldsChange: PropTypes.func.isRequired,
  handleOnDemandServiceTimeChange: PropTypes.func.isRequired,
};

export default OnDemandSlot;
